module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "business-form"
  }, [_c('h6', {
    staticClass: "title"
  }, [_vm._v("业务情况")]), _vm._v(" "), _c('div', {
    staticClass: "v-com-form"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.result,
      "rules": _vm.rules,
      "label-width": "84px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户来源",
      "prop": "CustomerSource_Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择客户来源",
      "disabled": _vm.CustomerSourceDisabled
    },
    model: {
      value: (_vm.result.CustomerSource_Id),
      callback: function($$v) {
        _vm.$set(_vm.result, "CustomerSource_Id", $$v)
      },
      expression: "result.CustomerSource_Id"
    }
  }, _vm._l((_vm.customerSourceList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "意向级别",
      "prop": "CustomerLevel_Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择意向级别",
      "disabled": _vm.CustomerLevelDisabled
    },
    model: {
      value: (_vm.result.CustomerLevel_Id),
      callback: function($$v) {
        _vm.$set(_vm.result, "CustomerLevel_Id", $$v)
      },
      expression: "result.CustomerLevel_Id"
    }
  }, _vm._l((_vm.customerLevelList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册资本",
      "prop": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.result.RegisteredCapital),
      callback: function($$v) {
        _vm.$set(_vm.result, "RegisteredCapital", $$v)
      },
      expression: "result.RegisteredCapital"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人数规模",
      "prop": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.result.EmployeeNums),
      callback: function($$v) {
        _vm.$set(_vm.result, "EmployeeNums", $$v)
      },
      expression: "result.EmployeeNums"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司资质",
      "prop": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.result.Qualification),
      callback: function($$v) {
        _vm.$set(_vm.result, "Qualification", $$v)
      },
      expression: "result.Qualification"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-430999c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/components/business-form/index.vue
// module id = 1470
// module chunks = 1